export type SlotType = {
  fuseTag: string;
  id: string;
};

export type SlotConfigType = {
  Startpage: {
    [key: string]: SlotType;
  };
  Profile: {
    [key: string]: SlotType;
  };
  Login: {
    [key: string]: SlotType;
  };
};

export const adSlotConfigPublift: SlotConfigType = {
  Startpage: {
    // <!-- GAM 71161633/XING_xing/Homepage_HREC_1 -->
    top: {
      id: 'startpage-reklame-top',
      fuseTag: 'Homepage_HREC_1',
    },
    // <!-- GAM 71161633/XING_xing/Homepage_HREC_2 -->
    bottom: {
      id: 'startpage-reklame-bottom',
      fuseTag: 'Homepage_HREC_2',
    },
  },
  Profile: {
    // <!-- GAM 71161633/XING_xing/Profile_Sidebar_VREC -->
    sidebar: {
      id: 'profile-reklame-sidebar',
      fuseTag: 'Profile_Sidebar_VREC',
    },
    // <!-- GAM 71161633/XING_xing/Profile_Incontent_1 -->
    content: {
      id: 'profile-reklame-content',
      fuseTag: 'Profile_Incontent_1',
    },
  },
  Login: {
    // <!-- GAM 71161633/XING_xing/Login_HREC -->
    content: {
      id: 'login-reklame-content',
      fuseTag: 'Login_HREC',
    },
  },
};

export const getAdSlotIds = (section: Record<string, SlotType>): string[] =>
  Object.values(section).map(({ id }) => id);
